var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['sider-trigger-a', _vm.collapsed ? 'collapsed' : ''],attrs:{"type":"text"},on:{"click":_vm.handleChange}},[_c('Icon',{attrs:{"type":_vm.icon,"size":_vm.size}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d56d977","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/main/components/header-bar/sider-trigger/sider-trigger.vue
// module id = null
// module chunks = 